import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from 'utils/format';

const ProductPrice = ({ price, discountedPrice, currency, couponLine }) => (
  <>
    <div className={couponLine ? 'h3 mb-1' : 'h3 mb-3'}>
      {discountedPrice != null ? (
        <span className="coupon-reveal d-inline-flex align-items-baseline flex-wrap">
          <span className="text-success mr-2">
            {formatPrice(discountedPrice, currency, true)}
          </span>
          <s className="h5 text-light mb-0">{formatPrice(price, currency, true)}</s>
        </span>
      ) : (
        formatPrice(price, currency, true)
      )}
    </div>
    {couponLine && <div className="coupon-reveal small text-success mb-3">{couponLine}</div>}
  </>
);

ProductPrice.propTypes = {
  price: PropTypes.number,
  discountedPrice: PropTypes.number,
  currency: PropTypes.string,
  couponLine: PropTypes.string,
};

export default ProductPrice;
